/**
 * インクリメンタル検索用に文字列を正規化する。
 * - NFKC (全角→半角アルファ数字、合成文字)
 * - 小文字化
 * - ひらがな→カタカナ (「に」と「ニ」を同一視)
 * - 空白除去
 */
export const normalizeForSearch = (s: string): string =>
  s
    .normalize('NFKC')
    .toLowerCase()
    .replace(/[ぁ-ゖ]/g, (m) =>
      String.fromCharCode(m.charCodeAt(0) + 0x60),
    )
    .replace(/\s+/g, '')
